import { render } from "./edit-pack.vue?vue&type=template&id=f4d10e42&lang=pug"
import script from "./edit-pack.vue?vue&type=script&lang=js"
export * from "./edit-pack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__